<template>
  <div class="operate">
    <div v-if="Number(rowData.admin_is_super) !== 1">
      <a @click="deleteRowAccount"  href="javascript:;">删除</a>
      <a @click="updateAccount" href="javascript:;">编辑</a>
    </div>
   <div v-else>
     <a href="javascript:;" style="color: #748BA3">——</a>
     <a href="javascript:;" style="color: #748BA3">——</a>
   </div>
  </div>
</template>
<script>
export default {
  name: 'accountOperate',
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    // 编辑
    updateAccount() {
      // 如果进入了 编辑 就本地存储一个值
      localStorage.setItem('isNull', 'true')
      localStorage.setItem('routeName', this.$route.name)
      this.$router.push({
        name: 'editAccount',
        query: {
          name: this.rowData['admin_name'],
          id: this.rowData['admin_id'],
          gid: this.rowData['admin_gid']
        }
      })
    },
    // 删除
    deleteRowAccount() {
      this.$emit('on-custom-comp', { index: this.index })
    }
  }
}
</script>
